/* Counter Store Locator widget.
 * Requires: maplibre-gl (JS+CSS), counter-locator.css, data/stores.json, logos/.
 * Usage: CounterLocator.init({ el: '#counter-locator', dataUrl: 'data/stores.json', logoBase: 'logos/' })
 */
(function () {
  "use strict";

  var PIN_SVG = '<svg class="pin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z"/></svg>';
  var SEARCH_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>';
  var MAP_STYLE = "https://tiles.openfreemap.org/styles/bright";
  var PAGE_SIZE = 25;

  var S = {
    data: null, map: null, markers: {}, popup: null,
    center: null, results: [], page: 0, selected: null,
    activeFilters: new Set(), tab: "instore", expandedStore: null,
    root: null, opts: null, acTimer: null, acItems: [], acIndex: -1,
    analyticsFails: 0, userChoseLocation: false,
    searchOrigin: null, originMarker: null, originPopup: null,
    locationIntent: 0, locationRequests: new Set(), fitPending: false,
    mapUnavailable: false, searchBound: false, mapExplored: false
  };
  // Fallback view center when IP geolocation is blocked: US population centroid,
  // so the default list leads with mid-country stores instead of raw file order.
  var DEFAULT_CENTER = { lat: 39.5, lng: -96.5, isDefault: true };

  /* ---------------- analytics ---------------- */
  var WIDGET_V = "3";
  function stableId(store, key) {
    try {
      var v = store.getItem(key);
      if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); store.setItem(key, v); }
      return v;
    } catch (e) { return Math.random().toString(36).slice(2) + Date.now().toString(36); }
  }
  function browserId(which, key) {
    try { return stableId(window[which], key); }
    catch (e) { return Math.random().toString(36).slice(2); }
  }
  var SESSION = browserId("sessionStorage", "cw_sid");
  var VISITOR = browserId("localStorage", "cw_vid");
  var INTERNAL = false;
  try {
    if (/[?&]cl_debug=1/.test(location.search)) localStorage.setItem("cw_internal", "1");
    if (/[?&]cl_debug=0/.test(location.search)) localStorage.removeItem("cw_internal");
    INTERNAL = localStorage.getItem("cw_internal") === "1";
  } catch (e) { /* storage blocked */ }
  function nearestMi() {
    var f = S.results && S.results[0];
    return f && f.d != null ? Math.round(f.d * 10) / 10 : null;
  }
  function track(event, props) {
    if (!S.opts || S.opts.disableAnalytics) return;
    // Search data can contain a home address. Apply minimization before EVERY
    // sink, including failures and restored locations. Store coordinates are public.
    props = Object.assign({}, props || {});
    if (event === "search" || event === "locate") {
      delete props.query; delete props.resolved_label;
      delete props.lat; delete props.lng;
    }
    var row = {
      session_id: SESSION,
      visitor_id: VISITOR,
      v: WIDGET_V,
      event: event,
      tab: S.tab,
      is_mobile: window.matchMedia("(max-width: 767px)").matches,
      referrer: safePageUrl(document.referrer),
      href: safePageUrl(location.href),
      ua: (navigator.userAgent || "").slice(0, 160)
    };
    if (INTERNAL) row.internal = true;
    Object.keys(props).forEach(function (k) { if (props[k] != null) row[k] = props[k]; });
    // Sink 1: GA4 / GTM if the site runs it
    try {
      if (window.dataLayer) window.dataLayer.push({ event: "locator_" + event, locator: props });
      if (typeof window.gtag === "function") window.gtag("event", "locator_" + event, props);
    } catch (e) { /* analytics must never break the widget */ }
    // Sink 2: first-party capture (Supabase REST, insert-only anon policy)
    var a = S.opts.analytics;
    if (a && a.url && a.anonKey && S.analyticsFails < 3) {
      try {
        var hdrs = { "Content-Type": "application/json", "apikey": a.anonKey, "Prefer": "return=minimal" };
        if (a.anonKey.indexOf("eyJ") === 0) hdrs["Authorization"] = "Bearer " + a.anonKey; // legacy JWT keys only
        fetch(a.url.replace(/\/$/, "") + "/rest/v1/locator_event", {
          method: "POST", keepalive: true, headers: hdrs,
          body: JSON.stringify(row)
        }).then(function (r) { if (!r.ok) S.analyticsFails++; })
          .catch(function () { S.analyticsFails++; });
      } catch (e) { /* ignore */ }
    }
  }
  function activeFilterNames() {
    return Array.from(S.activeFilters).map(function (pi) {
      var p = S.data.products[pi]; return p.name + " " + p.size;
    }).join("; ").slice(0, 300) || null;
  }

  /* ---------------- utils ---------------- */
  function safePageUrl(value) {
    try { var u = new URL(value); return (u.origin + u.pathname).slice(0, 300); }
    catch (e) { return ""; }
  }
  function motion(ms) { return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : ms; }
  function validPoint(pt) {
    return !!pt && Number.isFinite(pt.lat) && Number.isFinite(pt.lng) &&
      Math.abs(pt.lat) <= 90 && Math.abs(pt.lng) <= 180;
  }
  function requestJSON(url, locationRequest, timeoutMs) {
    var controller = new AbortController();
    var timedOut = false;
    if (locationRequest) S.locationRequests.add(controller);
    var timer = setTimeout(function () { timedOut = true; controller.abort(); }, timeoutMs || S.opts.requestTimeout || 8000);
    return fetch(url, { signal: controller.signal }).then(function (r) {
      if (!r.ok) throw new Error("service-unavailable");
      return r.json();
    }).catch(function (e) {
      if (timedOut) throw new Error("service-timeout");
      throw e;
    }).finally(function () {
      clearTimeout(timer); S.locationRequests.delete(controller);
    });
  }
  function newLocationIntent() {
    S.locationIntent++;
    clearTimeout(S.acTimer);
    S.locationRequests.forEach(function (c) { c.abort(); });
    S.locationRequests.clear();
    return S.locationIntent;
  }
  function h(html) { var t = document.createElement("template"); t.innerHTML = html.trim(); return t.content.firstChild; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function haversine(a, b) {
    var R = 3958.8, dLat = (b.lat - a.lat) * Math.PI / 180, dLng = (b.lng - a.lng) * Math.PI / 180;
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * Math.PI / 180) * Math.cos(b.lat * Math.PI / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(Math.min(1, Math.max(0, s))));
  }
  function logoUrl(banner, pin) {
    var slug = S.data.logos[banner];
    if (!slug) return null;
    // Two artwork sets: "list" (authentic brand proportions, breathing room)
    // and "pin" (high-fill for map visibility). Exact per-file URLs preferred.
    var urls = pin ? (S.opts.logoUrlsPin || S.opts.logoUrls) : S.opts.logoUrls;
    if (urls && urls[slug]) return urls[slug];
    var base = pin ? (S.opts.logoPinBase || S.opts.logoBase) : S.opts.logoBase;
    return base.indexOf("{slug}") >= 0 ? base.replace("{slug}", slug) : base + slug + ".png";
  }
  var STORE_GLYPH = '<svg viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg" style="position:absolute;inset:22%;width:56%;height:56%;fill:#bbb"><path d="M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"/></svg>';
  function logoEl(banner, cls, pin) {
    var u = logoUrl(banner, pin);
    return '<span class="cw-logo ' + (cls || "") + '"><span class="cw-logo-circle">' +
      (u ? '<img alt="" loading="lazy" src="' + esc(u) + '">' : STORE_GLYPH) + "</span></span>";
  }
  function storeAddr(st) { return st.a + ", " + st.c + ", " + st.s + " " + st.z; }
  function mapsUrl(st) { return "https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent((st.r === "Walmart" ? "Walmart, " : "") + storeAddr(st)); }
  function prodUrl(st, pi) { var m = S.data.urls[st.r]; return m ? m[String(pi)] : null; }

  /* ---------------- geocoding ---------------- */
  var fullZips = null;
  var zipPromise = null;
  function buildZipTable() {
    // Store coordinates are never a substitute for a searched ZIP's centroid.
    // Keep this boot hook so store data and the independent ZIP index stay decoupled.
  }
  function loadFullZips() {
    if (fullZips) return Promise.resolve(fullZips);
    if (zipPromise) return zipPromise;
    if (!S.opts.zipsUrl) return Promise.reject(new Error("zip-index-unavailable"));
    zipPromise = requestJSON(S.opts.zipsUrl, false).then(function (d) {
      if (!d || typeof d !== "object" || Array.isArray(d)) throw new Error("invalid-zip-index");
      fullZips = d;
      return d;
    }).finally(function () { zipPromise = null; });
    return zipPromise;
  }
  function zipLookup(z) {
    var v = fullZips && fullZips[z];
    if (!v || !validPoint({ lat: v[0], lng: v[1] })) return null;
    return {
      pt: { lat: v[0], lng: v[1] },
      label: z + " (" + [v[2], v[3]].filter(Boolean).join(", ") + ")",
      primary: z, secondary: [v[2], v[3]].filter(Boolean).join(", "),
      kind: "zip", precision: "approximate", zip: z
    };
  }
  function zipSuggestions(q) {
    return Object.keys(fullZips || {}).filter(function (z) { return z.indexOf(q) === 0; })
      .sort().map(zipLookup).filter(Boolean).slice(0, 5);
  }
  function addressItem(f, provider) {
    var p = f.properties || {};
    var country = p.countrycode || p.country_code;
    if (String(country || "").toUpperCase() !== "US") return null;
    var coords = f.geometry && f.geometry.coordinates;
    var pt = coords && { lat: coords[1], lng: coords[0] };
    if (!validPoint(pt)) return null;
    var street = p.street || (provider === "photon" && p.type === "street" ? p.name : "") || "", house = p.housenumber || "";
    var city = p.city || p.town || p.village || p.locality || p.county || "";
    var state = p.state_code || p.state || "";
    var secondary = [city, [state, p.postcode].filter(Boolean).join(" ")].filter(Boolean).join(", ");
    var primary = [house, street].filter(Boolean).join(" ") || p.name || city || state;
    if (!primary) return null;
    if (primary === city) secondary = [state, p.postcode].filter(Boolean).join(" ");
    if (primary === state) secondary = p.postcode || "";
    var kind = house && street ? "address" : street ? "street" : "city";
    // A house result is an address match, not a guarantee of rooftop precision.
    var precision = kind === "address" ? "address" : "approximate";
    if (provider === "geoapify" && p.rank && p.rank.match_type === "match_by_city_or_disrict") precision = "approximate";
    return { pt: pt, primary: primary, secondary: secondary,
      label: [primary, secondary].filter(Boolean).join(", "), kind: kind, precision: precision,
      house: String(house), street: street };
  }
  // Photon is a fuzzy place search. Validate numbered street queries ourselves:
  // sharing a house number must never make an unrelated street a suggestion.
  function addressTokens(text) {
    var aliases = { st: "street", rd: "road", ave: "avenue", av: "avenue", blvd: "boulevard",
      dr: "drive", ln: "lane", ct: "court", cir: "circle", pl: "place", pkwy: "parkway",
      ter: "terrace", hwy: "highway", n: "north", s: "south", e: "east", w: "west",
      ne: "northeast", nw: "northwest", se: "southeast", sw: "southwest" };
    return String(text).toLowerCase().replace(/[^a-z0-9-]+/g, " ").trim().split(/\s+/)
      .filter(Boolean).map(function (word) { return aliases[word] || word; });
  }
  function localityTokens(text) {
    var states = "Alabama:AL|Alaska:AK|Arizona:AZ|Arkansas:AR|California:CA|Colorado:CO|Connecticut:CT|Delaware:DE|District of Columbia:DC|Florida:FL|Georgia:GA|Hawaii:HI|Idaho:ID|Illinois:IL|Indiana:IN|Iowa:IA|Kansas:KS|Kentucky:KY|Louisiana:LA|Maine:ME|Maryland:MD|Massachusetts:MA|Michigan:MI|Minnesota:MN|Mississippi:MS|Missouri:MO|Montana:MT|Nebraska:NE|Nevada:NV|New Hampshire:NH|New Jersey:NJ|New Mexico:NM|New York:NY|North Carolina:NC|North Dakota:ND|Ohio:OH|Oklahoma:OK|Oregon:OR|Pennsylvania:PA|Rhode Island:RI|South Carolina:SC|South Dakota:SD|Tennessee:TN|Texas:TX|Utah:UT|Vermont:VT|Virginia:VA|Washington:WA|West Virginia:WV|Wisconsin:WI|Wyoming:WY";
    states.split("|").sort(function (a, b) { return b.length - a.length; }).forEach(function (entry) {
      var pair = entry.split(":");
      text = text.replace(new RegExp("\\b" + pair[0] + "\\b", "ig"), pair[1]);
    });
    return addressTokens(text.replace(/\b(\d{5})-\d{4}\b/g, "$1"));
  }
  function matchesNumberedQuery(item, query) {
    if (!query) return true;
    if (item.kind !== "address" && item.kind !== "street") return false;
    if (item.kind === "address" && item.house.toLowerCase() !== query[1].toLowerCase()) return false;
    var streetText = query[2].replace(/(?:,\s*|\s+)(?:apt\.?|apartment|unit|suite|ste\.?|#)\s*[a-z0-9-]+/ig, "");
    var wanted = addressTokens(streetText), actual = addressTokens(item.street);
    if (!wanted.length || !actual.length) return false;
    var direction = /^(north|south|east|west|northeast|northwest|southeast|southwest)$/;
    if (direction.test(actual[0]) && !direction.test(wanted[0])) {
      actual.shift();
      item.requiresSelection = true;
    }
    // Street words must match in order from the start, with prefix completion
    // only on the final typed word. Locality words can follow the street.
    var locality = localityTokens(item.secondary), at = 0;
    wanted = wanted.slice(0, actual.length).concat(localityTokens(wanted.slice(actual.length).join(" ")));
    if (wanted.length < actual.length || (wanted.length === actual.length && wanted[wanted.length - 1] !== actual[actual.length - 1])) item.requiresSelection = true;
    return wanted.every(function (word, i) {
      var last = i === wanted.length - 1;
      if (i < actual.length) return actual[i] === word || (last && actual[i].indexOf(word) === 0);
      while (at < locality.length) {
        var candidate = locality[at++];
        if (candidate === word || (last && candidate.indexOf(word) === 0)) return true;
      }
      return false;
    });
  }
  var houseAddressIndex = null;
  function autocomplete(q) {
    if (/^\s*\d+[a-z]?(?:-\d+[a-z]?)?(?:\s+\d\/\d)?\s+/i.test(q) && S.opts.addressIndexUrl) {
      if (!window.CounterAddressIndex) return Promise.reject(new Error("address-index-unavailable"));
      if (window.CounterAddressIndex.parseQuery && !window.CounterAddressIndex.parseQuery(q)) return Promise.resolve([]);
      if (!houseAddressIndex) houseAddressIndex = window.CounterAddressIndex.create({ manifestUrl: S.opts.addressIndexUrl, timeout: S.opts.requestTimeout || 8000 });
      var indexIntent = S.locationIntent;
      function checkIndexIntent() {
        if (indexIntent !== S.locationIntent) { var aborted = new Error("Aborted"); aborted.name = "AbortError"; throw aborted; }
      }
      return houseAddressIndex.search(q, { bias: S.searchOrigin, limit: 8 }).then(function (items) {
        checkIndexIntent();
        return items.length ? items : placeAutocomplete(q, true);
      }, function (error) {
        checkIndexIntent();
        if (error.name === "AbortError") throw error;
        return placeAutocomplete(q, true).then(function (items) {
          if (!items.length) throw error;
          return items;
        });
      });
    }
    return placeAutocomplete(q);
  }
  function placeAutocomplete(q, housesOnly) {
    var config = S.opts.geocoder || { provider: "photon" };
    var provider = config.provider || "photon";
    var url, intent = S.locationIntent;
    var numberedQuery = q.match(/^\s*(\d+[a-z]?(?:-\d+)?)\s+(.{2,})$/i);
    function photonUrl(query, streetOnly) {
      var result = (config.endpoint || "https://photon.komoot.io/api/") +
        "?limit=20&lang=en&countrycode=US&q=" + encodeURIComponent(query);
      // Prefer the chosen search area, never a panned camera or exact GPS point.
      // Rounding keeps the external bias at neighborhood scale.
      if (!numberedQuery && S.searchOrigin && validPoint(S.searchOrigin)) {
        result += "&lat=" + S.searchOrigin.lat.toFixed(2) + "&lon=" + S.searchOrigin.lng.toFixed(2) + "&zoom=10";
      }
      return result + (streetOnly ? "&layer=street" : "");
    }
    function uniqueItems(features) {
      var seen = new Set();
      return features.map(function (f) { return addressItem(f, provider); }).filter(function (item) {
        if (!item || (housesOnly && item.kind !== "address") || !matchesNumberedQuery(item, numberedQuery)) return false;
        if (numberedQuery && item.kind === "street") item.matchNote = "Street match (house number unverified)";
        var key = item.label.toLowerCase().replace(/\s+/g, " ");
        if (seen.has(key)) return false;
        seen.add(key); return true;
      }).sort(function (a, b) { return (a.kind === "address" ? 0 : 1) - (b.kind === "address" ? 0 : 1); });
    }
    if (provider === "geoapify") {
      if (!config.apiKey) return Promise.reject(new Error("address-search-unavailable"));
      url = (config.endpoint || "https://api.geoapify.com/v1/geocode/autocomplete") +
        "?limit=5&lang=en&filter=countrycode:us&text=" + encodeURIComponent(q) + "&apiKey=" + encodeURIComponent(config.apiKey);
    } else if (provider === "photon") {
      url = photonUrl(q, false);
    } else {
      return Promise.reject(new Error("address-search-unavailable"));
    }
    return requestJSON(url, true).then(function (d) {
      if (!Array.isArray(d.features)) throw new Error("service-unavailable");
      var items = uniqueItems(d.features);
      var streetQuery = numberedQuery;
      if (housesOnly || provider !== "photon" || items.length >= 5 || !streetQuery ||
          !/[a-z]/i.test(streetQuery[2]) || intent !== S.locationIntent) {
        return items.slice(0, provider === "photon" ? 8 : 5);
      }
      // Sparse house-number coverage must not become invented address matches.
      // Offer actual named streets separately and keep usable primary results.
      return requestJSON(photonUrl(streetQuery[2], true), true, Math.min(S.opts.requestTimeout || 8000, 2500)).then(function (fallback) {
        if (!Array.isArray(fallback.features)) return items.slice(0, 8);
        var labels = new Set(items.map(function (item) { return item.label.toLowerCase().replace(/\s+/g, " "); }));
        uniqueItems(fallback.features).forEach(function (item) {
          var key = item.label.toLowerCase().replace(/\s+/g, " ");
          if (item.kind !== "street" || labels.has(key)) return;
          item.matchNote = "Street match (house number unverified)";
          labels.add(key); items.push(item);
        });
        return items.slice(0, 8);
      }).catch(function (e) {
        if (e.name === "AbortError") throw e;
        return items.slice(0, 8);
      });
    });
  }
  function geocode(q) {
    var mzip = q.trim().match(/^(\d{5})(-\d{4})?$/);
    if (mzip) {
      return loadFullZips().then(function () {
        var item = zipLookup(mzip[1]);
        return item ? [item] : [];
      });
    }
    return autocomplete(q.trim());
  }

  /* ---------------- chosen location ---------------- */
  function originDescription(origin) {
    if (origin.kind === "gps") return "Your location";
    return (origin.precision === "approximate" ? "Approximate search location: " : "Search location: ") + origin.label;
  }
  function updateOriginMarker() {
    var origin = S.searchOrigin;
    var summary = S.root.querySelector(".cw-location-summary");
    var recenter = S.root.querySelector(".cw-recenter");
    summary.hidden = !origin;
    recenter.hidden = !origin || !S.mapExplored || S.mapUnavailable;
    if (!origin) return;
    summary.querySelector(".cw-location-text").textContent = origin.label;
    summary.querySelector(".cw-location-precision").textContent = origin.kind === "gps" ? "Your location" :
      origin.precision === "approximate" ? "Approximate search location" : "Search location";
    summary.title = originDescription(origin);
    if (!S.map || S.mapUnavailable) return;
    if (!S.originMarker) {
      var el = h('<button type="button" class="cw-origin"><span class="cw-origin-dot" aria-hidden="true"></span></button>');
      el.addEventListener("click", function (e) {
        e.stopPropagation();
        if (S.originPopup) S.originPopup.remove();
        var content = document.createElement("div");
        content.textContent = originDescription(S.searchOrigin);
        S.originPopup = new maplibregl.Popup({ offset: 18, maxWidth: "280px" })
          .setLngLat([S.searchOrigin.lng, S.searchOrigin.lat]).setDOMContent(content).addTo(S.map);
      });
      S.originMarker = new maplibregl.Marker({ element: el, anchor: "center" })
        .setLngLat([origin.lng, origin.lat]).addTo(S.map);
    }
    S.originMarker.setLngLat([origin.lng, origin.lat]);
    var marker = S.originMarker.getElement();
    marker.setAttribute("aria-label", originDescription(origin));
    marker.title = originDescription(origin);
    marker.classList.toggle("is-approximate", origin.precision === "approximate");
  }
  function commitLocation(item, intent, explicit) {
    if (intent !== S.locationIntent || !item || !validPoint(item.pt)) return false;
    S.searchOrigin = Object.freeze({ lat: item.pt.lat, lng: item.pt.lng,
      label: item.label, kind: item.kind || "city", precision: item.precision || "approximate" });
    S.center = S.searchOrigin; // compatibility: never the camera or a selected store
    S.mapExplored = false;
    if (explicit) S.userChoseLocation = true;
    S.root.querySelector(".cw-search input").value = item.label;
    if (S.originPopup) { S.originPopup.remove(); S.originPopup = null; }
    if (S.popup) { S.popup.remove(); S.popup = null; }
    showSearchError(""); setSearchStatus("");
    computeResults(true);
    S.fitPending = true;
    renderList(); updateOriginMarker();
    S.root.querySelector(".cw-results-status").textContent = S.matchCount + " matching stores. Results updated for " + item.label + ".";
    if (explicit) rememberLocation(S.searchOrigin);
    track(explicit && item.kind !== "gps" ? "search" : "locate", {
      via: item.kind, result_count: S.matchCount, nearest_mi: nearestMi()
    });
    return true;
  }
  function recenterOrigin() {
    if (!S.searchOrigin || !S.map) return;
    S.mapExplored = false;
    S.fitPending = false;
    fitToResults(S.results.slice(0, PAGE_SIZE));
    updateOriginMarker();
    track("recenter", { via: "search_origin" });
  }
  function markMapExplored() {
    if (!S.searchOrigin || !S.map || S.mapUnavailable) return;
    S.mapExplored = true;
    S.root.querySelector(".cw-recenter").hidden = false;
  }

  /* ---------------- results ---------------- */
  function computeResults(resetSelection) {
    var c = S.searchOrigin || S.center;
    var list = S.data.stores.filter(function (st) {
      if (S.activeFilters.size === 0) return true;
      return st.p.some(function (pi) { return S.activeFilters.has(pi); });
    });
    if (c) {
      list.forEach(function (st) { st.d = c.isDefault ? null : haversine(c, st); });
      var sc = c.isDefault ? function (st) { return haversine(c, st); } : function (st) { return st.d; };
      list.sort(function (a, b) { return sc(a) - sc(b); });
    }
    S.matchCount = list.length;
    S.results = list;
    S.page = 0;
    if (resetSelection || !list.some(function (st) { return st.id === S.selected; })) {
      S.selected = null; S.expandedStore = null;
      if (S.popup) { S.popup.remove(); S.popup = null; }
    } else if (S.popup && (!S.popup.isOpen || S.popup.isOpen())) {
      openPopup(list.find(function (st) { return st.id === S.selected; }));
    }
  }

  /* ---------------- render: store list ---------------- */
  function renderList() {
    var wrap = S.root.querySelector(".cw-list");
    wrap.innerHTML = "";
    var pageItems = S.results.slice(S.page * PAGE_SIZE, (S.page + 1) * PAGE_SIZE);
    if (S.searchOrigin && S.results.length && S.results[0].d > 25) {
      wrap.appendChild(h('<p class="cw-nearby-note">No matching stores within 25 miles. Showing the nearest options. You can also check Buy Online.</p>'));
    }
    wrap.appendChild(h('<p class="cw-availability-note">Products carried may vary. Confirm availability with the retailer.</p>'));
    if (!pageItems.length) {
      wrap.appendChild(h('<div class="cw-empty">No stores match these product filters. Clear the filters or check Buy Online.</div>'));
    }
    var ul = h('<ul aria-label="Store results"></ul>');
    pageItems.forEach(function (st) {
      var count = filteredCount(st);
      var li = h('<li class="cw-store' + (S.selected === st.id ? ' selected' : '') + '" tabindex="0" id="cw_store_' + esc(st.id) + '">' +
        '<div class="cw-store-name">' + logoEl(st.r) + "<span>" + esc(st.r) + "</span></div>" +
        '<div class="cw-addr cw-address">' + esc(storeAddr(st)) + "</div>" +
        (st.d != null ? '<div class="cw-dist">' + fmtDist(st.d) + "</div>" : "") +
        (st.x === 0 ? '<div class="cw-pin-precision">Map pin is approximate</div>' : "") +
        '<a class="cw-directions" href="' + esc(mapsUrl(st)) + '" target="_blank" rel="noopener noreferrer" aria-label="Get directions to ' + esc(st.r + ', ' + storeAddr(st)) + ' (Google Maps, opens in a new tab)">Get directions</a>' +
        '<button class="cw-found" aria-expanded="false">' + foundLabel(count) + "</button>" +
        "</li>");
      li.addEventListener("click", function (e) { if (e.target.closest("a,button")) return; selectStore(st, "list"); });
      li.addEventListener("keydown", function (e) { if (e.target === li && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); selectStore(st, "list"); } });
      li.querySelector(".cw-found").addEventListener("click", function (e) { e.stopPropagation(); toggleStoreProducts(st, li); });
      li.querySelector(".cw-directions").addEventListener("click", function (e) {
        e.stopPropagation();
        track("directions", { store_id: st.id, retailer: st.r, url: mapsUrl(st) });
      });
      ul.appendChild(li);
    });
    wrap.appendChild(ul);
    renderPager();
    updateFilterBtn();
    renderMarkers(pageItems);
    if (S.expandedStore) {
      var expanded = pageItems.find(function (st) { return st.id === S.expandedStore; });
      if (expanded) toggleStoreProducts(expanded, wrap.querySelector("#cw_store_" + CSS.escape(String(expanded.id))), true);
    }
  }
  function fmtDist(d) { return (d < 10 ? Math.round(d * 10) / 10 : Math.round(d)) + " mi"; }
  function foundLabel(count) {
    return count + " product" + (count === 1 ? "" : "s") + " found";
  }
  function showSearchError(msg) {
    var el = S.root && S.root.querySelector(".cw-search-error");
    if (!el) return;
    if (msg) { el.textContent = msg; el.hidden = false; }
    else { el.textContent = ""; el.hidden = true; }
  }
  function setSearchStatus(msg, busy) {
    var el = S.root.querySelector(".cw-search-status");
    if (el) { el.textContent = msg; el.hidden = !msg; }
    S.root.querySelector(".cw-search").setAttribute("aria-busy", String(!!busy));
  }
  function filteredCount(st) {
    if (S.activeFilters.size === 0) return st.p.length;
    return st.p.filter(function (pi) { return S.activeFilters.has(pi); }).length;
  }
  function renderPager() {
    var total = Math.max(1, Math.ceil(S.results.length / PAGE_SIZE));
    var el = S.root.querySelector(".cw-pager");
    el.querySelector(".prev").disabled = S.page <= 0;
    el.querySelector(".next").disabled = S.page >= total - 1;
    el.querySelector(".cw-pager-info").textContent = "Page " + (S.page + 1) + " of " + total;
    el.style.display = S.tab !== "online" && S.tab !== "map" && S.results.length > PAGE_SIZE ? "" : "none";
  }
  function toggleStoreProducts(st, li, silent) {
    if (!li) return;
    var open = li.querySelector(".cw-store-products");
    var fbtn = li.querySelector(".cw-found");
    if (open) { open.remove(); S.expandedStore = null; if (fbtn) fbtn.setAttribute("aria-expanded", "false"); return; }
    S.root.querySelectorAll(".cw-store-products").forEach(function (n) { n.remove(); });
    S.root.querySelectorAll(".cw-found[aria-expanded=true]").forEach(function (n) { n.setAttribute("aria-expanded", "false"); });
    if (fbtn) fbtn.setAttribute("aria-expanded", "true");
    S.expandedStore = st.id;
    var pis = S.activeFilters.size ? st.p.filter(function (pi) { return S.activeFilters.has(pi); }) : st.p;
    var ul = h('<ul class="cw-store-products" aria-label="Products at this store"></ul>');
    pis.forEach(function (pi) {
      var p = S.data.products[pi];
      var u = prodUrl(st, pi);
      var row = h("<li>" +
        '<img alt="" loading="lazy" src="' + esc(p.img) + '">' +
        '<span class="pn">' + esc(p.name) + "<small>" + esc(p.size) + "</small></span>" +
        (u ? '<a class="cw-sp-btn" href="' + esc(u) + '" target="_blank" rel="noopener">Shop Now<span class="sr-only"> ' + esc(p.name) + " " + esc(p.size) + " at " + esc(st.r) + "</span></a>" : "") +
        "</li>");
      var a = row.querySelector(".cw-sp-btn");
      if (a) a.addEventListener("click", function () {
        track("shop_now", { store_id: st.id, retailer: st.r, product: p.name + " " + p.size, url: u });
      });
      ul.appendChild(row);
    });
    li.appendChild(ul);
    if (!silent) track("products_expand", { store_id: st.id, retailer: st.r });
  }

  /* ---------------- map ---------------- */
  function makeMarker(st) {
    var el = h('<button type="button" class="cw-marker" data-id="' + esc(st.id) + '" aria-label="' + esc(st.r + ', ' + storeAddr(st)) + '"><span class="cw-marker-inner">' + PIN_SVG + logoEl(st.r, "", true) + "</span></button>");
    el.addEventListener("click", function (e) { e.stopPropagation(); selectStore(st, "pin"); });
    return new maplibregl.Marker({ element: el, anchor: "bottom" }).setLngLat([st.lng, st.lat]).addTo(S.map);
  }
  function matchesFilters(st) {
    return S.activeFilters.size === 0 || st.p.some(function (pi) { return S.activeFilters.has(pi); });
  }
  // Markers are viewport-driven and clustered at wide zooms:
  // individual branded pins for as long as possible, rolled-up count bubbles
  // only when the view is too wide for single stores to make sense.
  // Tuning knobs (radius/maxZoom/minPoints) are exposed via opts.cluster.
  // Values chosen by the 2026-07-29 parameter-sweep swarm (18 combos, 5 scenarios):
  // clusters only at zoom <= 7 (nation/state views), individual branded pins from
  // metro zoom inward, national frame ~18 markers with all map labels readable.
  var CLUSTER = { radius: 80, maxZoom: 12, minPoints: 3 };
  var storesById = null;
  function storesFC() {
    var feats = [];
    S.data.stores.forEach(function (st) {
      if (!matchesFilters(st)) return;
      feats.push({ type: "Feature", properties: { id: String(st.id) },
        geometry: { type: "Point", coordinates: [st.lng, st.lat] } });
    });
    return { type: "FeatureCollection", features: feats };
  }
  function ensureClusterSource() {
    if (!S.map || !S.data || S.clusterReady) return;
    if (!S.map.isStyleLoaded()) { S.map.once("load", ensureClusterSource); return; }
    storesById = {};
    S.data.stores.forEach(function (st) { storesById[String(st.id)] = st; });
    S.map.addSource("stores", {
      type: "geojson", data: storesFC(),
      cluster: true, clusterRadius: CLUSTER.radius,
      clusterMaxZoom: CLUSTER.maxZoom, clusterMinPoints: CLUSTER.minPoints
    });
    // invisible-but-queryable layer: queryRenderedFeatures on it returns exactly
    // the clusters/points for the CURRENT zoom's tiles (querySourceFeatures
    // leaks stale features from previously loaded zoom levels)
    S.map.addLayer({ id: "stores-ghost", type: "circle", source: "stores",
      paint: { "circle-radius": 8, "circle-opacity": 0 } });
    S.clusterReady = true;
    S.map.on("sourcedata", function (e) {
      if (e.sourceId === "stores" && e.isSourceLoaded) syncViewportMarkers();
    });
    syncViewportMarkers();
  }
  function clusterSize(count) {
    return count >= 200 ? 60 : count >= 50 ? 52 : count >= 10 ? 44 : 36;
  }
  function makeClusterMarker(f) {
    var count = f.properties.point_count;
    var px = clusterSize(count);
    var el = h('<button type="button" class="cw-cluster" aria-label="' + count + ' stores in this area. Zoom in." style="width:' + px + "px;height:" + px + 'px"><span>' + esc(f.properties.point_count_abbreviated) + "</span></button>");
    var cid = f.properties.cluster_id;
    var coords = f.geometry.coordinates;
    el.addEventListener("click", function (e) {
      e.stopPropagation();
      markMapExplored();
      var fallback = function () { S.map.easeTo({ center: coords, zoom: S.map.getZoom() + 2, duration: motion(500) }); };
      try {
        S.map.getSource("stores").getClusterExpansionZoom(cid).then(function (z) {
          S.map.easeTo({ center: coords, zoom: Math.min(z + 0.3, 16), duration: motion(500) });
        }).catch(fallback);
      } catch (err) { fallback(); }
      track("cluster_zoom", { result_count: count, lat: coords[1], lng: coords[0] });
    });
    return new maplibregl.Marker({ element: el, anchor: "center" }).setLngLat(coords).addTo(S.map);
  }
  function syncViewportMarkers() {
    if (!S.map || !S.data) return;
    if (!S.clusterReady) { ensureClusterSource(); return; }
    var feats;
    try { feats = S.map.queryRenderedFeatures({ layers: ["stores-ghost"] }); }
    catch (e) { feats = []; }
    var want = {}, seen = {}, shown = 0;
    for (var i = 0; i < feats.length; i++) {
      var f = feats[i];
      var key = f.properties.cluster ? "c" + f.properties.cluster_id : "s" + f.properties.id;
      if (seen[key]) continue;
      seen[key] = true;
      want[key] = f;
      shown++;
    }
    Object.keys(S.markers).forEach(function (k) {
      if (!want[k]) { S.markers[k].remove(); delete S.markers[k]; }
    });
    Object.keys(want).forEach(function (k) {
      if (S.markers[k]) return;
      var f = want[k];
      if (f.properties.cluster) {
        S.markers[k] = makeClusterMarker(f);
      } else {
        var st = storesById[f.properties.id];
        if (st) S.markers[k] = makeMarker(st);
      }
    });
    if (S.selected != null && S.markers["s" + S.selected]) {
      S.markers["s" + S.selected].getElement().classList.add("selected");
    }
  }
  function refreshClusterData() {
    if (S.map && S.clusterReady && S.map.getSource("stores")) S.map.getSource("stores").setData(storesFC());
  }
  function renderMarkers(pageItems) {
    S.lastPage = pageItems;
    if (!S.map) return;
    if (S.fitPending) { fitToResults(pageItems); S.fitPending = false; }
    updateOriginMarker();
    syncViewportMarkers();
  }
  function isMobile() { return window.matchMedia("(max-width: 767px)").matches; }
  function fitPadding() {
    var width = S.root.clientWidth || window.innerWidth;
    return isMobile()
      ? { top: 233, bottom: 90, left: 32, right: 60 }
      : { top: width < 1100 ? 205 : 140, bottom: 80, left: Math.min(380, width * 0.42), right: 80 };
  }
  function fitToResults(pageItems, bounds) {
    if (!S.map || !pageItems) return;
    if (S.searchOrigin) {
      var b2 = new maplibregl.LngLatBounds();
      b2.extend([S.searchOrigin.lng, S.searchOrigin.lat]);
      pageItems.slice(0, 6).forEach(function (st) { b2.extend([st.lng, st.lat]); });
      S.map.fitBounds(b2, { padding: fitPadding(), maxZoom: 13, duration: motion(700) });
    } else {
      if (!pageItems.length) return;
      if (!bounds) {
        bounds = new maplibregl.LngLatBounds();
        pageItems.forEach(function (st) { bounds.extend([st.lng, st.lat]); });
      }
      S.map.fitBounds(bounds, { padding: fitPadding(), maxZoom: 11, duration: 0 });
    }
  }
  function selectStore(st, source) {
    var fromList = source === "list";
    S.selected = st.id;
    track("store_select", { store_id: st.id, retailer: st.r, lat: st.lat, lng: st.lng, via: source });
    S.root.querySelectorAll(".cw-store").forEach(function (n) { n.classList.toggle("selected", n.id === "cw_store_" + st.id); });
    Object.keys(S.markers).forEach(function (k) { S.markers[k].getElement().classList.toggle("selected", k === "s" + st.id); });
    if (!fromList) {
      var li = S.root.querySelector("#cw_store_" + CSS.escape(String(st.id)));
      if (li) li.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
    if (!S.map) return;
    markMapExplored();
    S.map.easeTo({ center: [st.lng, st.lat], zoom: Math.max(S.map.getZoom(), 12), duration: motion(500), padding: fitPadding() });
    openPopup(st);
  }
  function openPopup(st) {
    if (!S.map) return;
    if (S.popup) S.popup.remove();
    var count = filteredCount(st);
    var node = h('<div><div class="cw-pop-name">' + logoEl(st.r) + "<b>" + esc(st.r) + "</b></div>" +
      '<div class="cw-pop-body">' + esc(storeAddr(st)) +
      (st.x === 0 ? '<div class="cw-pin-precision">Map pin is approximate. Directions use the street address.</div>' : "") +
      '<br><a class="cw-directions" href="' + esc(mapsUrl(st)) + '" target="_blank" rel="noopener noreferrer" aria-label="Get directions to ' + esc(st.r + ', ' + storeAddr(st)) + ' (Google Maps, opens in a new tab)">Get directions</a>' +
      '<br><button class="cw-found" aria-expanded="false">' + foundLabel(count) + "</button></div></div>");
    node.querySelector(".cw-directions").addEventListener("click", function (e) {
      e.stopPropagation();
      track("directions", { store_id: st.id, retailer: st.r, url: mapsUrl(st), via: "map" });
    });
    node.querySelector(".cw-found").addEventListener("click", function (e) {
      // On mobile the list panel is hidden behind the Map tab: jump to it so
      // the expansion is actually visible.
      if (isMobile()) setTab("instore");
      var li = S.root.querySelector("#cw_store_" + CSS.escape(String(st.id)));
      if (!li) {
        // Find the store's page without replacing the shopper's search origin.
        var index = S.results.findIndex(function (item) { return item.id === st.id; });
        if (index < 0) return;
        S.page = Math.floor(index / PAGE_SIZE);
        renderList();
        li = S.root.querySelector("#cw_store_" + CSS.escape(String(st.id)));
      }
      if (li && !li.querySelector(".cw-store-products")) toggleStoreProducts(st, li);
      if (li) li.scrollIntoView({ block: "center", behavior: "smooth" });
      e.target.setAttribute("aria-expanded", String(!!(li && li.querySelector(".cw-store-products"))));
    });
    S.popup = new maplibregl.Popup({ offset: [0, -46], className: "flyout", maxWidth: "260px" })
      .setLngLat([st.lng, st.lat]).setDOMContent(node).addTo(S.map);
  }

  /* ---------------- filters panel ---------------- */
  function renderFilters() {
    var grid = S.root.querySelector(".cw-prodgrid");
    grid.innerHTML = "";
    var carried = new Set();
    S.data.stores.forEach(function (st) {
      (st.p || []).forEach(function (pi) { carried.add(pi); });
    });
    S.data.products.forEach(function (p, pi) {
      if (!carried.has(pi)) return;
      var card = h('<button class="cw-prodcard' + (S.activeFilters.has(pi) ? " on" : "") + '" role="checkbox" aria-checked="' + S.activeFilters.has(pi) + '">' +
        '<img alt="" loading="lazy" src="' + esc(p.img) + '"><span class="n">' + esc(p.name) + '</span><span class="s">' + esc(p.size) + "</span></button>");
      card.addEventListener("click", function () {
        if (S.activeFilters.has(pi)) S.activeFilters.delete(pi); else S.activeFilters.add(pi);
        card.classList.toggle("on"); card.setAttribute("aria-checked", S.activeFilters.has(pi));
        computeResults(); refreshClusterData(); renderList(); updateFilterBtn();
        if (S.tab === "online") renderOnline();
        track("filter_change", { filters: activeFilterNames(), result_count: S.matchCount });
      });
      grid.appendChild(card);
    });
  }
  function updateFilterBtn() {
    var b = S.root.querySelector(".cw-filter-btn");
    b.textContent = S.activeFilters.size ? "Filters (" + S.activeFilters.size + ")" : "Filters";
    var done = S.root.querySelector(".cw-filters-done");
    if (done) {
      var n = S.matchCount || 0;
      done.textContent = "Show " + n.toLocaleString() + " store" + (n === 1 ? "" : "s");
    }
  }

  /* ---------------- Buy Online tab ---------------- */
  function renderOnline() {
    var wrap = S.root.querySelector(".cw-online");
    wrap.innerHTML = "";
    S.data.online.forEach(function (o) {
      if (S.activeFilters.size && !Array.from(S.activeFilters).some(function (pi) {
        var p = S.data.products[pi]; return p.name === o.product && p.size === o.size;
      })) return;
      if (!o.retailers.length) return; // no online retailers: don't render a dead section
      var sec = h('<section class="cw-online-section"><h2 class="cw-online-title">' + esc(o.product) + " | " + esc(o.size) + "</h2></section>");
      var row = h('<div class="cw-online-row"><a class="cw-online-img" href="' + esc(o.pdp) + '" target="_blank" rel="noopener"><img alt="' + esc(o.product) + '" loading="lazy" src="' + esc(o.img) + '"></a><div class="cw-online-list"></div></div>');
      row.querySelector(".cw-online-img").addEventListener("click", function () {
        track("pdp_click", { product: o.product + " " + o.size, url: o.pdp });
      });
      var list = row.querySelector(".cw-online-list");
      var vis = o.retailers.slice(0, 2), hid = o.retailers.slice(2);
      vis.forEach(function (r) { list.appendChild(retailerRow(r, o)); });
      if (hid.length) {
        var more = h('<button class="cw-more" aria-expanded="false">' + hid.length + " more retailer" + (hid.length === 1 ? "" : "s") + " ▾</button>");
        more.addEventListener("click", function () {
          hid.forEach(function (r) { list.appendChild(retailerRow(r, o)); });
          more.remove();
        });
        sec.appendChild(row); sec.appendChild(more);
      } else { sec.appendChild(row); }
      wrap.appendChild(sec);
    });
  }
  function retailerRow(r, o) {
    var row = h('<div class="cw-retailer-row">' + logoEl(r.name) +
      '<span class="rn">' + esc(r.name) + "</span>" +
      '<a class="cw-shop-btn" role="link" href="' + esc(r.url) + '" target="_blank" rel="noopener">Shop Now<span class="sr-only"> ' + esc(o.product) + " at " + esc(r.name) + "</span></a></div>");
    row.querySelector(".cw-shop-btn").addEventListener("click", function () {
      track("shop_now", { retailer: r.name, product: o.product + " " + o.size, url: r.url });
    });
    return row;
  }

  /* ---------------- tabs ---------------- */
  function setTab(tab, silent) {
    if (!S.data) return;
    if (tab === "map" && S.mapUnavailable) tab = "instore";
    var fromTab = S.tab;
    S.tab = tab;
    S.root.classList.toggle("map-open", tab === "map");
    S.root.classList.toggle("list-open", tab !== "map");
    S.root.classList.toggle("online-open", tab === "online");
    if (tab !== "map" && S.popup) { S.popup.remove(); S.popup = null; }
    var showOnline = tab === "online";
    S.root.querySelector(".cw-list").style.display = showOnline || tab === "map" ? "none" : "";
    S.root.querySelector(".cw-online").style.display = showOnline ? "" : "none";
    S.root.querySelector(".cw-pager").style.display = showOnline || tab === "map" ? "none" : (S.results.length > PAGE_SIZE ? "" : "none");
    S.root.querySelectorAll(".cw-tab").forEach(function (b) {
      var on = b.dataset.tab === tab;
      b.classList.toggle("active", on); b.setAttribute("aria-selected", on);
      b.setAttribute("tabindex", on ? "0" : "-1");
    });
    if (showOnline) renderOnline();
    if (tab === "map") {
      if (S.initMap) S.initMap();
      if (S.map) { S.map.resize(); updateOriginMarker(); }
    }
    if (!silent) track("tab_switch", { via: fromTab + ">" + tab });
  }

  /* ---------------- search UI ---------------- */
  function bindSearch() {
    if (S.searchBound) return;
    S.searchBound = true;
    var input = S.root.querySelector(".cw-search input");
    var ac = S.root.querySelector(".cw-ac");
    function hideAc() {
      ac.hidden = true; ac.innerHTML = ""; S.acItems = []; S.acIndex = -1;
      input.setAttribute("aria-expanded", "false"); input.removeAttribute("aria-activedescendant");
    }
    S.hideSuggestions = hideAc;
    function choose(item) {
      var intent = newLocationIntent();
      hideAc();
      commitLocation(item, intent, true);
      if (isMobile()) input.blur(); else input.focus();
    }
    function showAcItems(items) {
      S.acItems = items; S.acIndex = -1;
      if (!items.length) { hideAc(); return; }
      ac.innerHTML = "";
      items.forEach(function (it, index) {
        var li = h('<li id="cw-location-option-' + index + '" role="option" aria-label="' + esc(it.label + (it.matchNote ? '. ' + it.matchNote : '')) + '" aria-selected="false">' +
          '<span class="cw-ac-primary">' + esc(it.primary || it.label) + '</span>' +
          (it.secondary ? '<span class="cw-ac-secondary">' + esc(it.secondary) + '</span>' : '') +
          (it.matchNote ? '<span class="cw-ac-secondary">' + esc(it.matchNote) + '</span>' : '') + '</li>');
        li.addEventListener("mousedown", function (e) { e.preventDefault(); });
        li.addEventListener("click", function () { choose(it); });
        ac.appendChild(li);
      });
      ac.hidden = false;
      input.setAttribute("aria-expanded", "true");
      input.removeAttribute("aria-activedescendant");
    }
    function reportError(e, intent) {
      if (intent !== S.locationIntent || e.name === "AbortError") return;
      hideAc(); setSearchStatus("");
      showSearchError("Location search is temporarily unavailable. Try again or enter a 5-digit ZIP.");
    }
    function submit() {
      var q = input.value.trim();
      if (!q) { input.focus(); return; }
      var intent = newLocationIntent();
      hideAc(); showSearchError(""); setSearchStatus("Finding your location…", true);
      geocode(q).then(function (items) {
        if (intent !== S.locationIntent) return;
        setSearchStatus("");
        if (!items.length) {
          showSearchError("We couldn't find that US location. Add a city or ZIP and try again.");
          track("search", { via: "no_match", result_count: 0 });
          return;
        }
        var streetOnly = /^\d+[a-z]?(?:-\d+)?\s+/i.test(q) && items.every(function (item) { return item.kind === "street"; });
        if (items.length === 1 && !streetOnly && !items[0].requiresSelection) { commitLocation(items[0], intent, true); hideAc(); if (isMobile()) input.blur(); }
        else {
          showAcItems(items);
          setSearchStatus(streetOnly ? "House number not found. Choose an approximate street location or add a city or ZIP." : "Choose a location from the suggestions.");
          input.focus();
        }
      }).catch(function (e) { reportError(e, intent); });
    }
    input.addEventListener("input", function () {
      var intent = newLocationIntent();
      var q = input.value.trim();
      hideAc(); showSearchError(""); setSearchStatus("");
      if (/^\d{1,5}$/.test(q)) {
        if (q.length < 2) return;
        setSearchStatus("Finding ZIP codes…", true);
        loadFullZips().then(function () {
          if (intent !== S.locationIntent || document.activeElement !== input) return;
          var items = zipSuggestions(q);
          showAcItems(items);
          setSearchStatus(items.length ? items.length + " ZIP suggestions available." : "No matching ZIP codes.");
        }).catch(function (e) { reportError(e, intent); });
        return;
      }
      if (q.length < 3 || /^\d+$/.test(q)) return;
      S.acTimer = setTimeout(function () {
        setSearchStatus("Finding locations…", true);
        autocomplete(q).then(function (items) {
          if (intent !== S.locationIntent || document.activeElement !== input) return;
          showAcItems(items);
          setSearchStatus(items.length ? items.length + " suggestions available. Use arrow keys to choose." : "No suggestions. Add a city or ZIP.");
        }).catch(function (e) { reportError(e, intent); });
      }, 250);
    });
    input.addEventListener("keydown", function (e) {
      if (e.isComposing) return;
      if (e.key === "Enter") {
        e.preventDefault();
        if (S.acIndex >= 0 && S.acItems[S.acIndex]) choose(S.acItems[S.acIndex]); else submit();
      } else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        if (ac.hidden) return;
        e.preventDefault();
        if (S.acIndex < 0) S.acIndex = e.key === "ArrowDown" ? 0 : S.acItems.length - 1;
        else S.acIndex = (S.acIndex + (e.key === "ArrowDown" ? 1 : -1) + S.acItems.length) % S.acItems.length;
        [].forEach.call(ac.children, function (n, i) { n.setAttribute("aria-selected", String(i === S.acIndex)); });
        var selected = ac.children[S.acIndex];
        input.setAttribute("aria-activedescendant", selected.id);
        selected.scrollIntoView({ block: "nearest" });
      } else if (e.key === "Escape") {
        newLocationIntent(); hideAc(); setSearchStatus(""); showSearchError("");
      }
    });
    input.addEventListener("blur", function () {
      setTimeout(function () { if (document.activeElement !== input) { hideAc(); setSearchStatus(""); } }, 150);
    });
    S.root.querySelector(".cw-clear-btn").addEventListener("click", function () {
      newLocationIntent(); input.value = ""; hideAc(); setSearchStatus(""); showSearchError(""); input.focus();
    });
    S.root.querySelector(".cw-search-btn").addEventListener("click", submit);
  }

  /* ---------------- initial location ---------------- */
  function requestPreciseLocation(userInitiated) {
    var intent = userInitiated ? newLocationIntent() : S.locationIntent;
    if (userInitiated && S.hideSuggestions) S.hideSuggestions();
    if (!navigator.geolocation) {
      if (userInitiated) showSearchError("Your browser cannot share your location. Enter an address, city, or ZIP.");
      return;
    }
    function ask() {
      if (intent !== S.locationIntent) return;
      if (userInitiated) { showSearchError(""); setSearchStatus("Finding your location…", true); }
      navigator.geolocation.getCurrentPosition(function (pos) {
        if (intent !== S.locationIntent || (!userInitiated && S.userChoseLocation)) return;
        commitLocation({ pt: { lat: pos.coords.latitude, lng: pos.coords.longitude },
          label: "Your location", kind: "gps", precision: "gps" }, intent, userInitiated);
      }, function (err) {
        if (intent !== S.locationIntent || !userInitiated) return;
        setSearchStatus("");
        showSearchError(err && err.code === 1
          ? "Location permission is off. Enter an address, city, or ZIP, or enable location in your browser."
          : "We couldn't get your location. Try again or enter an address, city, or ZIP.");
      }, { timeout: 8000, maximumAge: 300000 });
    }
    if (userInitiated) return ask();
    // Never interrupt a first visit with an unsolicited location permission prompt.
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: "geolocation" }).then(function (p) {
        if (p.state === "granted") ask();
      }).catch(function () { /* IP estimate or manual search remains available */ });
    }
  }
  var IP_PROVIDERS = [
    { url: "https://ipapi.co/json/", parse: function (d) {
        return d && !d.error && d.country_code === "US"
          ? { pt: { lat: d.latitude, lng: d.longitude }, label: [d.city, d.region_code].filter(Boolean).join(", ") } : null; } },
    { url: "https://ipwho.is/", parse: function (d) {
        return d && d.success && d.country_code === "US"
          ? { pt: { lat: d.latitude, lng: d.longitude }, label: [d.city, d.region_code].filter(Boolean).join(", ") } : null; } }
  ];
  function rememberLocation(origin) {
    try {
      // Precise search locations are session-only, never a 90-day browser record.
      sessionStorage.setItem("cw_location_v3", JSON.stringify({ origin: origin, t: Date.now() }));
      localStorage.removeItem("cw_loc");
    } catch (e) { /* blocked storage must not affect search */ }
  }
  function savedLocation() {
    try {
      localStorage.removeItem("cw_loc");
      var saved = JSON.parse(sessionStorage.getItem("cw_location_v3") || "null");
      if (saved && validPoint(saved.origin) && typeof saved.origin.label === "string" &&
          saved.origin.label.length <= 400 && Date.now() - saved.t >= 0 && Date.now() - saved.t < 86400000) {
        return { pt: { lat: saved.origin.lat, lng: saved.origin.lng }, label: saved.origin.label,
          kind: saved.origin.kind, precision: saved.origin.precision };
      }
    } catch (e) { /* corrupt or blocked storage */ }
    return null;
  }
  function ipLocate(i, intent) {
    if (i >= IP_PROVIDERS.length || intent !== S.locationIntent) return;
    var p = IP_PROVIDERS[i];
    requestJSON(p.url, true).then(function (d) {
      if (intent !== S.locationIntent || S.userChoseLocation || (S.searchOrigin && S.searchOrigin.kind === "gps")) return;
      var hit = p.parse(d);
      if (!hit || !validPoint(hit.pt) || !hit.label) return ipLocate(i + 1, intent);
      hit.kind = "ip"; hit.precision = "approximate";
      commitLocation(hit, intent, false);
    }).catch(function (e) {
      if (e.name !== "AbortError") ipLocate(i + 1, intent);
    });
  }
  function detectLocation() {
    var saved = savedLocation();
    if (saved) {
      commitLocation(saved, S.locationIntent, true);
      return;
    }
    if (S.opts.autoLocate === false) return;
    ipLocate(0, S.locationIntent);
    requestPreciseLocation(false);
  }

  /* ---------------- boot ---------------- */
  function buildShell(root) {
    root.classList.add("cw", "list-open");
    var GPS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"/></svg>';
    // Note: .cw-map is intentionally LAST in the DOM (absolute positioning makes
    // order invisible) so MapLibre's canvas/attribution tab-stops come after all
    // widget controls and results.
    root.innerHTML =
      '<a class="cw-skip" href="#cw-results">Skip to results</a>' +
      '<div class="cw-controls">' +
        '<button class="cw-filter-btn" aria-expanded="false" aria-label="Product Filter">Filters</button>' +
        '<div class="cw-search"><label class="cw-search-tip" for="cw-location-input">Address, city, or ZIP</label>' +
          '<input id="cw-location-input" role="combobox" aria-label="Search address, city, or ZIP" aria-autocomplete="list" aria-expanded="false" aria-controls="cw-location-options" aria-describedby="cw-location-status" autocomplete="off" autocapitalize="off" enterkeyhint="search" spellcheck="false" placeholder="Enter a location">' +
          '<button type="button" class="cw-clear-btn" aria-label="Clear search" title="Clear search">×</button>' +
          '<button class="cw-gps-btn" aria-label="Use my location" title="Use my location">' + GPS_SVG + "</button>" +
          '<button class="cw-search-btn" aria-label="Search">' + SEARCH_SVG + "</button>" +
          '<ul id="cw-location-options" class="cw-ac" role="listbox" aria-label="Location suggestions" hidden></ul>' +
          '<div class="cw-search-error" role="alert" hidden></div>' +
          '<div id="cw-location-status" class="cw-search-status" role="status" aria-live="polite" hidden></div>' +
        "</div>" +
      "</div>" +
      '<div class="cw-filters" hidden>' +
        '<div class="cw-filters-head"><h3>Filter by product</h3><button class="cw-filters-reset">Reset</button></div>' +
        '<div class="cw-prodgrid" role="group" aria-label="Product filters"></div>' +
        '<div class="cw-filters-foot"><button class="cw-filters-done">Show stores</button></div>' +
      "</div>" +
      '<div class="cw-panel">' +
        '<div class="cw-tabs" role="tablist" aria-label="Shopping options">' +
          '<button id="cw-map-tab" class="cw-tab cw-tab-map" role="tab" data-tab="map" aria-selected="false" aria-controls="cw-map" tabindex="-1">Map</button>' +
          '<button id="cw-list-tab" class="cw-tab active" role="tab" data-tab="instore" aria-selected="true" aria-controls="cw-results" tabindex="0">Store List</button>' +
          '<button id="cw-online-tab" class="cw-tab" role="tab" data-tab="online" aria-selected="false" aria-controls="cw-online" tabindex="-1">Buy Online</button>' +
        "</div>" +
        '<div class="cw-list" id="cw-results" role="tabpanel" aria-labelledby="cw-list-tab" tabindex="-1"><p class="cw-empty" role="status">Loading stores…</p></div>' +
        '<div class="cw-online" id="cw-online" role="tabpanel" aria-labelledby="cw-online-tab" style="display:none"></div>' +
        '<div class="cw-pager" style="display:none">' +
          '<button class="cw-pager-btn prev">Previous</button>' +
          '<span class="cw-pager-info"></span>' +
          '<button class="cw-pager-btn next">Next</button>' +
        "</div>" +
      "</div>" +
      '<div class="cw-location-summary" hidden><small class="cw-location-precision"></small><span class="cw-location-text"></span></div>' +
      '<div class="cw-results-status cw-origin-label" role="status" aria-live="polite" aria-atomic="true"></div>' +
      '<div class="cw-map-message" role="status" hidden></div>' +
      '<div class="cw-mapctl">' +
        '<button type="button" class="cw-recenter" hidden>Back to search location</button>' +
        '<div class="cw-zoom"><button class="zin" aria-label="Zoom in">+</button><button class="zout" aria-label="Zoom out">−</button></div>' +
      "</div>" +
      '<div id="cw-map" class="cw-map" role="region" aria-label="Store map"></div>';
    if (S.opts.geocoder && S.opts.geocoder.provider === "geoapify") {
      var credit = document.createElement("div");
      credit.className = "cw-geocoder-credit";
      credit.innerHTML = 'Address search by <a href="https://www.geoapify.com/" target="_blank" rel="noopener noreferrer">Geoapify</a> | <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">© OpenStreetMap contributors</a>';
      root.appendChild(credit);
    }
    if (S.opts.addressIndexUrl) {
      var addressCredit = document.createElement("div");
      addressCredit.className = "cw-geocoder-credit";
      addressCredit.style.left = "auto";
      addressCredit.style.right = "44px";
      var sourcesLink = document.createElement("a");
      sourcesLink.href = new URL("sources.html", S.opts.addressIndexUrl).href;
      sourcesLink.target = "_blank";
      sourcesLink.rel = "noopener noreferrer";
      sourcesLink.textContent = "Address data sources";
      addressCredit.appendChild(sourcesLink);
      root.appendChild(addressCredit);
    }
  }

  function init(opts) {
    S.opts = Object.assign({ el: "#counter-locator", dataUrl: "data/stores.json", logoBase: "logos/", zipsUrl: null }, opts || {});
    S.root = typeof S.opts.el === "string" ? document.querySelector(S.opts.el) : S.opts.el;
    if (!S.root) return;
    S.root.dataset.locatorVersion = WIDGET_V;
    buildShell(S.root);
    setDataControls(false);

    // The host theme nukes button backgrounds on :focus (background:transparent
    // !important) unless the button carries its .alt-focus opt-out class.
    // Apply it to every widget button, including ones rendered later.
    function altFocus(root) {
      root.querySelectorAll("button:not(.alt-focus)").forEach(function (b) {
        b.classList.add("alt-focus"); b.type = "button";
      });
    }
    altFocus(S.root);
    new MutationObserver(function () { altFocus(S.root); })
      .observe(S.root, { childList: true, subtree: true });

    // Map init is deferred until the widget approaches the viewport: MapLibre +
    // style + sprites are ~545KB the shopper shouldn't pay above the fold.
    var mapStarted = false;
    S.initMap = function () {
      if (mapStarted) return;
      mapStarted = true;
      startMap();
    };
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { S.initMap(); io.disconnect(); }
      }, { rootMargin: "600px" });
      io.observe(S.root);
      setTimeout(S.initMap, 6000); // fallback: never leave the map uninitialized long
    } else {
      S.initMap();
    }

    bindControls();
    var breakpoint = window.matchMedia("(max-width: 767px)");
    function layoutChanged() {
      if (!isMobile() && S.tab === "map") setTab("instore", true);
      if (S.map) S.map.resize();
    }
    if (breakpoint.addEventListener) breakpoint.addEventListener("change", layoutChanged);
    loadData(0);
  }

  function setDataControls(ready) {
    S.root.querySelectorAll(".cw-controls input, .cw-controls button, .cw-tab, .cw-filters button").forEach(function (el) { el.disabled = !ready; });
  }
  function mapFailed() {
    S.mapUnavailable = true;
    S.clusterReady = false;
    S.markers = {};
    if (S.originMarker) { S.originMarker.remove(); S.originMarker = null; }
    if (S.map) { try { S.map.remove(); } catch (e) {} S.map = null; }
    S.root.classList.add("map-unavailable");
    var message = S.root.querySelector(".cw-map-message");
    message.textContent = "The map is unavailable. Search the store list and choose Get directions.";
    message.hidden = false;
    if (S.data && S.tab === "map") setTab("instore", true);
  }

  function startMap() {
    // Map is an enhancement: if MapLibre failed to load (CDN outage), the
    // list, search, filters, and Buy Online must all keep working.
    if (window.maplibregl) {
      try {
      S.map = new maplibregl.Map({
        container: S.root.querySelector(".cw-map"),
        style: MAP_STYLE,
        center: [-96.5, 39.2], zoom: 4,
        attributionControl: { compact: true }
      });
      } catch (e) { mapFailed(); return; }
      var mapTimer = setTimeout(function () {
        if (S.map && !S.map.isStyleLoaded()) mapFailed();
      }, S.opts.mapLoadTimeout || 15000);
      S.map.once("load", function () { clearTimeout(mapTimer); });
      // Counter map aesthetics: warm beige land, crisp state/country lines,
      // stronger state labels (the stock style's boundaries are muted dashes).
      S.map.on("style.load", function () {
        try {
          S.map.setPaintProperty("background", "background-color", "#f6efe2");
          ["landuse-residential", "landcover-sand"].forEach(function (id) {
            if (S.map.getLayer(id)) S.map.setPaintProperty(id, "fill-color", "#f2e9d8");
          });
          var A = Object.assign({
            stateColor: "hsl(28,10%,44%)", stateDash: null,
            stateWidth: ["interpolate", ["linear"], ["zoom"], 3, 0.9, 6, 1.5, 11, 2.6],
            countryColor: "hsl(248,6%,48%)",
            stateLabelColor: "#5a5044", stateLabelSize: 13
          }, S.opts.mapAesthetics || {});
          if (S.map.getLayer("boundary_3")) {
            S.map.setPaintProperty("boundary_3", "line-color", A.stateColor);
            S.map.setPaintProperty("boundary_3", "line-width", A.stateWidth);
            if (A.stateDash) S.map.setPaintProperty("boundary_3", "line-dasharray", A.stateDash);
            else S.map.setPaintProperty("boundary_3", "line-dasharray", [1, 0]);
            S.map.setLayerZoomRange("boundary_3", 2, 24);
          }
          if (S.map.getLayer("boundary_2")) {
            S.map.setPaintProperty("boundary_2", "line-color", A.countryColor);
          }
          if (S.map.getLayer("label_state")) {
            S.map.setPaintProperty("label_state", "text-color", A.stateLabelColor);
            if (A.stateLabelSize) S.map.setLayoutProperty("label_state", "text-size", A.stateLabelSize);
          }
        } catch (e) { /* style ids may change upstream; tint is cosmetic */ }
      });
      S.map.on("click", function () { if (S.popup) { S.popup.remove(); S.popup = null; } });
      S.map.on("error", function () {
        var message = S.root.querySelector(".cw-map-message");
        message.textContent = "Some map details could not load. The store list and directions are still available.";
        message.hidden = false;
      });
      S.map.on("moveend", syncViewportMarkers);
      S.map.on("movestart", function (e) { if (e && e.originalEvent) markMapExplored(); });
      S.map.on("load", ensureClusterSource);
      if (S.opts.cluster) Object.assign(CLUSTER, S.opts.cluster);
      if (S.data) ensureClusterSource();
      // Collapse the compact attribution (MapLibre leaves it expanded, which puts
      // its links early in the tab order).
      S.map.on("load", function () {
        var att = S.root.querySelector("details.maplibregl-ctrl-attrib");
        if (att) { att.removeAttribute("open"); att.classList.remove("maplibregl-compact-show"); }
      });
      if (S.lastPage) renderMarkers(S.lastPage);
      updateOriginMarker();
    } else {
      mapFailed();
    }
  }

  function bindControls() {
    // custom controls
    S.root.querySelector(".zin").addEventListener("click", function () { if (S.map) { markMapExplored(); S.map.zoomIn(); } });
    S.root.querySelector(".zout").addEventListener("click", function () { if (S.map) { markMapExplored(); S.map.zoomOut(); } });
    S.root.querySelector(".cw-recenter").addEventListener("click", recenterOrigin);

    S.root.querySelector(".cw-gps-btn").addEventListener("click", function () {
      requestPreciseLocation(true);
    });

    S.root.querySelectorAll(".cw-tab").forEach(function (b) {
      b.addEventListener("click", function () { setTab(b.dataset.tab); });
      b.addEventListener("keydown", function (e) {
        if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key)) return;
        e.preventDefault();
        var tabs = Array.from(S.root.querySelectorAll(".cw-tab")).filter(function (t) {
          return t.dataset.tab !== "map" || (isMobile() && !S.mapUnavailable);
        });
        var index = tabs.indexOf(b);
        var next = e.key === "Home" ? 0 : e.key === "End" ? tabs.length - 1 :
          (index + (e.key === "ArrowRight" ? 1 : -1) + tabs.length) % tabs.length;
        setTab(tabs[next].dataset.tab); tabs[next].focus();
      });
    });

    S.root.querySelector(".cw-pager .prev").addEventListener("click", function () {
      if (S.page > 0) { S.page--; renderList(); track("paginate", { page: S.page + 1 }); }
    });
    S.root.querySelector(".cw-pager .next").addEventListener("click", function () {
      var total = Math.ceil(S.results.length / PAGE_SIZE);
      if (S.page < total - 1) { S.page++; renderList(); track("paginate", { page: S.page + 1 }); }
    });

    var fbtn = S.root.querySelector(".cw-filter-btn");
    var fpanel = S.root.querySelector(".cw-filters");
    fbtn.addEventListener("click", function () {
      var open = fpanel.hidden;
      fpanel.hidden = !open;
      fbtn.setAttribute("aria-expanded", open);
      fbtn.classList.toggle("active", open);
    });
    S.root.querySelector(".cw-filters-reset").addEventListener("click", function () {
      S.activeFilters.clear(); renderFilters();
      computeResults(); refreshClusterData(); renderList(); updateFilterBtn();
      if (S.tab === "online") renderOnline();
      track("filter_change", { filters: "reset", result_count: S.matchCount });
    });
    S.root.querySelector(".cw-filters-done").addEventListener("click", function () {
      fpanel.hidden = true; fbtn.setAttribute("aria-expanded", "false"); fbtn.classList.remove("active");
      fbtn.focus();
    });
    document.addEventListener("click", function (e) {
      if (!fpanel.hidden && !e.target.closest(".cw-filters") && !e.target.closest(".cw-filter-btn")) {
        fpanel.hidden = true; fbtn.setAttribute("aria-expanded", "false"); fbtn.classList.remove("active");
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !fpanel.hidden) {
        fpanel.hidden = true; fbtn.setAttribute("aria-expanded", "false"); fbtn.classList.remove("active"); fbtn.focus();
      }
    });
  }

  function loadData(attempt) {
    requestJSON(S.opts.dataUrl, false).then(function (data) {
      if (!data || !Array.isArray(data.stores) || !data.stores.length || !Array.isArray(data.products) ||
          !Array.isArray(data.online) || !data.logos || !data.urls || data.stores.some(function (st) {
            return !validPoint(st) || !Array.isArray(st.p) || st.p.some(function (pi) { return !Number.isInteger(pi) || !data.products[pi]; });
          })) throw new Error("invalid-store-data");
      S.data = data;
      S.center = DEFAULT_CENTER;
      buildZipTable();
      renderFilters();
      bindSearch();
      ensureClusterSource();
      computeResults(true); S.fitPending = true; renderList();
      setDataControls(true);
      // Mobile leads with the map (Jeff, 2026-07-29): pins near you beat a list.
      if (isMobile() && !S.mapUnavailable) setTab("map", true);
      track("widget_load", { result_count: S.data.stores.length });
      detectLocation();
    }).catch(function () {
      if (attempt < 2) return setTimeout(function () { loadData(attempt + 1); }, 1500 * (attempt + 1));
      var wrap = S.root.querySelector(".cw-list");
      wrap.innerHTML = '<div class="cw-empty">We had trouble loading store data. ' +
        '<button class="cw-pager-btn" style="display:block;margin-top:10px">Try again</button></div>';
      wrap.querySelector("button").addEventListener("click", function () { loadData(0); });
    });
  }

  window.CounterLocator = { init: init, _state: S };
})();
